export const lg_policy = {
  policy_th: {
    privacy_consent: "เราให้ความสำคัญกับความเป็นส่วนตัวของคุณ",
    text1:"เว็บไซต์นี้ใช้คุกกี้และเก็บข้อมูลบางส่วนเพื่อปรับปรุงประสบการณ์การใช้งานของคุณ ให้การประชุมปลอดภัย และปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล (PDPA)",
    text2: "การใช้งานเว็บไซต์นี้ต่อ ถือว่าคุณยินยอมใน นโยบายความเป็นส่วนตัว และ ข้อกำหนดการใช้งาน",
    accept: "ยอมรับและดำเนินการต่อ",
    notaccept: "ไม่ยอมรับ",
    learn_more: "ดูรายละเอียด",
  },
  policy_en: {
    privacy_consent: "We care about your privacy",
    text1:"This website uses cookies and collects limited data to improve your experience, secure your meetings, and comply with the Personal Data Protection Act (PDPA).",
    text2: "By continuing to use our site, you agree to our Privacy Policy and Terms of Use.",
    accept: "Accept & Continue",
    notaccept: "Deny",
    learn_more: "Learn more",
  },
};
